<div class="menu-container" [class.opened]="isOpen" [class.closed]="!isOpen || isSmallScreen">
  <div class="menu-header" (click)="toggle()">
    <mat-icon [class.opened]="isOpen" [class.closed]="!isOpen">keyboard_double_arrow_right</mat-icon>
  </div>

  <!-- Admin Access Indicator with Menu -->
  <div class="admin-access-indicator" *ngIf="(isAdminAsWinery || showOnlyAdminMenu || showAccountSuperAdminPanel || canGrantSuperAdmin) && isOpen">
      <div *ngIf="(isAdminAsWinery || adminModule || showAccountSuperAdminPanel || canGrantSuperAdmin) && !isPublicRoute" class="adminBadge">
        <a (click)="goToDashboardAdmin()"><img alt="divinea" src="assets/images/admin_badge.png" /></a>
      </div>
    <div class="admin-indicator-content" (click)="toggleAdminMenu()">
      <mat-icon class="admin-icon" (click)="goToDashboardAdmin(); $event.stopPropagation()">admin_panel_settings</mat-icon>
      <div class="admin-text">
        <div class="admin-label-row">
          <span class="admin-label">{{ 'Admin Access' | translate }}</span>
          <button *ngIf="isAdminAsWinery || showOnlyAdminMenu" class="admin-logout-btn" (click)="logoutFromAdmin($event)"
            [wsTooltip]="'Exit from Admin section' | translate">
            <mat-icon>logout</mat-icon>
          </button>
        </div>
        <span class="winery-name" *ngIf="isAdminAsWinery">{{ currentWineryName }}</span>
      </div>
      <div class="admin-actions">
        <mat-icon class="admin-toggle-icon" [class.expanded]="isAdminMenuExpanded">keyboard_arrow_down</mat-icon>
      </div>
    </div>

    <!-- Admin Menu inside the indicator -->
    <div class="admin-menu-container" *ngIf="isAdminMenuExpanded">
      <ul class="admin-menu-list">
        <li class="admin-menu-item">
          <button class="admin-menu-button" (click)="goToDashboardAdmin()">
            <mat-icon class="admin-menu-icon">wine_bar</mat-icon>
            <span class="admin-menu-text">{{ 'Select Winery' | translate }}</span>
          </button>
        </li>
        <li class="admin-menu-item" *ngFor="let adminItem of adminMenuItems">
          <button class="admin-menu-button" (click)="goTo(adminItem.route)">
            <mat-icon class="admin-menu-icon">{{ adminItem.icon }}</mat-icon>
            <span class="admin-menu-text">{{ adminItem.label | translate }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>

  <div class="scrollbar-overflow-y" *ngIf="!showOnlyAdminMenu">
    <div class="menu-wrapper">
      <ul>
        <ng-container *ngFor="let item of menuItems">
          <li class="section-li button" [class.selected]="isLastSection(item)">
            <span class="menu-item-tooltip-host"
              [wsTooltip]="sectionTooltip(item)"
              [wsTooltipDisabled]="!sectionTooltip(item)">
              <button class="section-button" (click)="
                item.subItems?.length > 0
                  ? toggleSection(item.key)
                  : goTo(item.route)
              " [class.disabled]="item.disabled" [disabled]="item.disabled">
                <mat-icon class="icon-section">{{ item.icon }}</mat-icon>
                <strong class="text-section" *ngIf="isOpen">{{ item.label | translate }}</strong>
                <mat-icon *ngIf="item.subItems?.length > 0 && isOpen && !item.disabled" class="icon-section-expand"
                  [class.rotate]="menuState[item.key] && isOpen">arrow_drop_down</mat-icon>
              </button>
            </span>

            <!-- Sottomenu -->
            <ul *ngIf="item.subItems?.length > 0 && menuState[item.key] && isOpen">
              <li *ngFor="let subItem of item.subItems; let i = index" class="subsection-li sub-button"
                [class.selected]="isLastSection(subItem)" [hidden]="!isOpen">
                <span class="menu-item-tooltip-host"
                  [wsTooltip]="subItemTooltip(subItem)"
                  [wsTooltipDisabled]="!subItemTooltip(subItem)">
                  <button (click)="subItem.action ? subItem.action() : goTo(subItem.route)"
                    [class.disabled]="subItem.disabled" [disabled]="subItem.disabled"
                    class="subsection-button">
                    <strong class="text-subsection">{{ subItem.label | translate }}</strong>
                  </button>
                </span>
              </li>
            </ul>
          </li>
        </ng-container>
      </ul>
      <div class="sidenavFooter" *ngIf="isOpen">
        <span class="version">{{ versionText }}</span>
        <span *ngIf="!!!!versionPostfix" class="versionPostfix">({{ versionPostfix }})</span>
      </div>
    </div>
  </div>
</div>